{
  "scope": {
    "my_tasks": "Mes tâches",
    "delegated_tasks": "Tâches déléguées"
  },
  "status": {
    "open": "Ouvert",
    "completed": "Terminé",
    "overdue": "EN RETARD"
  },
  "dashboard": {
    "section_title": "Vos tâches ouvertes"
  },
  "actions": {
    "create_task": "Créer une tâche",
    "update_task": "Modifier la tâche",
    "save_task": "Enregistrer la tâche",
    "cancel_create_task": "Annuler la création de tâche"
  },
  "form": {
    "labels": {
      "due_date": "Date d'échéance",
      "assigned_to": "Assigné à",
      "requested_by": "Demandé par",
      "description": "Description"
    },
    "placeholders": {
      "assigned_to": "assigné à",
      "requested_by": "demandé par"
    },
    "validation": {
      "task_required": "Veuillez saisir une tâche",
      "date_too_old": "c'est trop ancien",
      "date_too_far": "c'est trop loin",
      "task_name_empty": "Le nom de la tâche ne peut pas être vide",
      "unexpected_error": "Une erreur inattendue s'est produite lors de l'ajout de la tâche."
    }
  },
  "table": {
    "headers": {
      "tasks": "Tâches",
      "priority": "Priorité",
      "due_date": "Date d'échéance",
      "assigned_to": "Assigné à",
      "source": "Source"
    }
  },
  "delete": {
    "confirmation_message": "Cliquez sur confirmer pour supprimer la tâche",
    "section_confirmation": "Cliquez sur confirmer pour supprimer la section"
  },
  "slide": {
    "labels": {
      "due_date": "Date d'échéance",
      "source": "Source",
      "assigned_to": "Assigné à",
      "requested_by": "Demandé par",
      "completed_by": "Terminé par",
      "description": "Description",
      "comments": "Commentaires"
    }
  },
  "sections": {
    "completed": "Terminé",
    "without_section": "Tâches sans section",
    "create": "Créer une section",
    "placeholder": "Saisir la section",
    "validation": {
      "name_empty": "Le nom de la section ne peut pas être vide",
      "unexpected_error": "Une erreur inattendue s'est produite lors de la création de la section."
    }
  },
  "empty_state": {
    "title": "Aucune tâche pour le moment",
    "description": "Commencez par créer une tâche et organiser votre travail"
  },
  "display": {
    "empty_value": "-"
  },
  "partials_form": {
    "labels": {
      "associated_company": "Entreprise associée",
      "contact": "Contact",
      "task": "Tâche",
      "due_date": "Date d'échéance",
      "assign_to": "Assigner à"
    },
    "placeholders": {
      "associated_company": "Entreprise associée",
      "contact": "Contact",
      "describe_task": "Décrivez la tâche"
    },
    "validation": {
      "company_required": "veuillez saisir une entreprise",
      "task_required": "Veuillez saisir une tâche",
      "date_too_old": "c'est trop ancien",
      "date_too_far": "c'est trop loin"
    },
    "buttons": {
      "add_task": "+ Tâche"
    },
    "modal": {
      "create_title": "Créer une tâche",
      "update_title": "Modifier la tâche"
    }
  },
  "add_task": {
    "placeholder": "Ajouter une nouvelle tâche...",
    "type_new": "Saisir une nouvelle tâche",
    "validation": {
      "name_empty": "Le nom de la tâche ne peut pas être vide",
      "unexpected_error": "Une erreur inattendue s'est produite lors de l'ajout de la tâche."
    }
  },
  "form_fields": {
    "placeholders": {
      "assigned_to_question": "Assigné à ?",
      "due_date_question": "Quand est-ce dû ?",
      "select_priority": "Sélectionner la priorité"
    }
  },
  "aria_labels": {
    "create_new_task": "créer une nouvelle tâche",
    "task_section_actions": "actions de section de tâche",
    "mark_completed": "Marquer comme tâche terminée",
    "mark_uncompleted": "Marquer comme tâche non terminée",
    "assign_to": "Assigner à",
    "select_priority": "sélectionner la priorité de la tâche",
    "rename_section": "Renommer la section",
    "new_section_name": "Nouveau nom de section"
  },
  "timeframes": {
    "overdue": "En retard",
    "today": "Aujourd'hui",
    "upcoming": "À venir"
  }
}
